const foodiesStatistics = {
  en: {
    translation: {
      name: "Name",
      foodies: "Foodies",
      favorite_foodtypes: "Favorite cuisines",
      customers_choices: "Your customers have chosen:",
      table_foodtypes_tooltip:
        "The types of cuisine preferred by your customers allow you to know the tastes of your clientele and offer them the most suitable dishes. Moreover, you can understand if you are adequately responding to their expectations and to your cuisine idea (e.g., if you attract fast-food lovers and you are aiming to the Michelin star something is not working)",
      target_gender: "Your target: gender",
      men: "Male",
      male: "Male",
      women: "Female",
      female: "Female",
      other: "?",
      other_label: "Unknown",
      target_gender_tooltip:
        "Knowing the gender of your customers will help you create special events and dedicated nights",
      target_ages: "Your target: age range",
      ages_description:
        "The age of your customers allows you to understand what services you can implement to attract them and what kind of clientele you need to extend your turnover. The needs of each person may vary according to sex and age",
      favorite_experience: "Favorite experience",
      favorite_experience_text:
        " of your foodies have chosen your business for ",
      breakfast: "breakfast",
      lunch: "lunch",
      dinner: "dinner",
      unknown: "Unknown",
      afterdinner: "afterdinner",
      apetizer: "apetizer",
      favorite_experience_tooltip:
        "This information allows you to think about what time slots to enhance. Furthermore, knowing the strengths of your business, are you sure that you are taking advantage of the correct hours for your business?"
    }
  },
  it: {
    translation: {
      name: "Nome",
      foodies: "Foodies",
      favorite_foodtypes: "Tipi di cucina preferiti",
      customers_choices: "I tuoi clienti hanno scelto:",
      table_foodtypes_tooltip:
        "I tipi di cucina preferiti dai clienti ti permettono di comprendere i gusti della tua clientela e proporgli i piatti più adatti. Inoltre, puoi comprendere se stai rispondendo a pieno alle loro aspettative e alla tua idea di cucina (ad es. se attrai amanti del fast food e punti alla stella Michelin qualcosa non funziona)",
      target_gender: "Il tuo target: il sesso",
      men: "Uomini",
      male: "Uomini",
      women: "Donne",
      female: "Donne",
      other: "?",
      other_label: "Non specificato",
      target_gender_tooltip:
        "Conoscere il sesso dei tuoi clienti ti può permettere di creare eventi e serate dedicate",
      target_ages: "Il tuo target: le fasce di età",
      ages_description:
        "L'età dei tuoi clienti ti permette di comprendere quali servizi puoi implementare per attirarli e a che tipo di clientela rivolgerti per allargare il giro d'affari. Le necessità di ogni persona variano a seconda del sesso e dell'anzianità",
      favorite_experience: "Esperienza preferita",
      favorite_experience_text: " dei foodies hanno scelto il tuo locale per ",
      breakfast: "colazione",
      lunch: "pranzo",
      dinner: "cena",
      unknown: "Sconosciuto",
      afterdinner: "afterdinner",
      apetizer: "aperitivo",
      favorite_experience_tooltip:
        "Il dato ti permette di pensare a quali fasce orarie potenziare. Inoltre, conoscendo i punti di forza del tuo locale, sei sicuro che stia sfruttando gli orari giusti?"
    }
  }
};

export default foodiesStatistics;
